import { render, staticRenderFns } from "./selectTable.vue?vue&type=template&id=f8cae32c"
import script from "./selectTable.vue?vue&type=script&lang=js"
export * from "./selectTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports